export const timecodeToTop = (displayedTextArray: string[]) => {
	const blocks = displayedTextArray.flatMap(s => s.split(/\r?\n\r?\n/))

	const out: string[] = []
	// timecode without spaces inside; spaces after the timecode are optional
	const TC = /^\[\d{2}:\d{2}\]$/
	const SPLIT = /(\[\d{2}:\d{2}\])\s/g

	for (const block of blocks) {
		// splitting and saving the timecodes themselves as separate elements
		const parts = block.split(SPLIT)

		for (let i = 0; i < parts.length; i++) {
			const part = parts[i]
			if (!part || /^\s+$/.test(part)) continue

			if (TC.test(part)) {
				// this is timecode
				out.push(part)
			} else {
				// this is the text (both after the timecode and without it) - adding it as it is
				out.push(part)
			}
		}
	}

	return out.join('\r\n\r\n')
}
